import { render } from "./Exhibitions.vue?vue&type=template&id=3c841920"
import script from "./Exhibitions.vue?vue&type=script&lang=js"
export * from "./Exhibitions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/samuelquaresma/Documents/Dev/DAF/app-capacitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__